import { TreeNode } from 'primeng/api';
export type CompaniesHouseAddress = {
  address3?: string;
  city?: string;
  state?: string;
  county?: string;
  address1: string;
  address2: string;
  careOf: string;
  country: string;
  locality: string;
  poBox: string;
  postalCode: string;
  premises: string;
  region: string;
};

export type CompaniesHouseOfficer = {
  isPrimary?: boolean;
  director?: string;
  email?: string;
  phoneNumber?: string;
  dob?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  middleName?: string;
  officerRole?: string;
  address?: CompaniesHouseAddress;
  appointedOn?: string;
  resignedOn?: string;
  nationality?: string;
  occupation?: string;
  dateOfBirth?: { day?: number; month: number; year: number };
  uniqueId?: string;
};

export type CompaniesHouseSearchResult = {
  companyName: string;
  companyNumber: string;
  companyStatus?: string;
  type?: string;
  dateOfCreation?: string;
  registeredOfficeAddress?: CompaniesHouseAddress;
};

export type CompaniesHouseSearchResponse = {
  result: CompaniesHouseSearchResult[] | CompaniesHouseNumberResult[];
  totalRecords: number;
  totalPages: number;
  page: number;
  limit: number;
};

export type CompaniesHouseNumberResult = {
  companyName: string;
  companyNumber: string;
  companyStatus?: string;
  dateOfCreation?: string;
  jurisdiction?: string;
  type?: string;
  undeliverableRegisteredOfficeAddress?: boolean;
  registeredOfficeIsInDispute?: boolean;
  registeredOfficeAddress?: CompaniesHouseAddress;
  serviceAddress?: CompaniesHouseAddress;
  officers?: {
    activeCount: number;
    resignedCount: number;
    totalResults: number;
    items: CompaniesHouseOfficer[];
  };
};

export enum CompaniesHouseSearchMode {
  BUSINESS_NUMBER_ONLY = 'business-number-only',
  BUSINESS_NUMBER_AND_ADDITIONAL = 'business-number-and-additional',
}

export enum CompaniesHouseAdditionalCriteria {
  COMPANY_NAME = 'company-name',
  LOCATION = 'location',
}

export const COMPANIES_HOUSE_REQUIRED_FIELDS: TreeNode[] = [
  { key: 'firstName', label: 'First name', data: { id: 'firstName', label: 'First name' } },
  { key: 'middleName', label: 'Middle name', data: { id: 'middleName', label: 'Middle name' } },
  { key: 'lastName', label: 'Last name', data: { id: 'lastName', label: 'Last name' } },
  { key: 'email', label: 'Email', data: { id: 'email', label: 'Email' } },
  {
    key: 'dob',
    label: 'Date of birth',
    data: { id: 'dob', label: 'Date of birth' },
  },
  {
    key: 'address',
    label: 'Address',
    data: { id: 'address', label: 'Address' },
    children: [
      {
        key: 'address1',
        label: 'Address line 1',
        data: { id: 'address1', label: 'Address line 1' },
      },
      {
        key: 'address2',
        label: 'Address line 2',
        data: { id: 'address2', label: 'Address line 2' },
      },
      {
        key: 'address3',
        label: 'Address line 3',
        data: { id: 'address3', label: 'Address line 3' },
      },
      {
        key: 'address4',
        label: 'Address line 4',
        data: { id: 'address4', label: 'Address line 4' },
      },
      {
        key: 'locality',
        label: 'Locality',
        data: { id: 'locality', label: 'Locality' },
      },
      {
        key: 'postalCode',
        label: 'Postal code',
        data: { id: 'postalCode', label: 'Postal code' },
      },
      {
        key: 'country',
        label: 'Country',
        data: { id: 'country', label: 'Country' },
      },
    ],
  },
  {
    key: 'nationality',
    label: 'Nationality',
    data: { id: 'nationality', label: 'Nationality' },
  },
];
